import { LOCAL__collection_cells_upsert } from '@/state/collection/cell/LOCAL__collection_cells_upsert';
import { LOCAL__images_upsert_meta } from '@/state/images/upsert_meta/LOCAL__images_upsert_meta_use';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO_IMAGE_META__base } from '@shared/dto/+image/meta/_base/DTO_IMAGE_META__base';
import { DTO_IMAGE_META__grid2d_cell_collection } from '@shared/dto/+image/meta/grid2d/DTO_IMAGE_META__grid2d_cell_collection';

export function HANDLER_CLIENT__image_meta_upsert(items: any) {
  assert_array_instanceof(items, DTO_IMAGE_META__base);

  for (let item of items) item.images__try_load();

  store.dispatch(LOCAL__images_upsert_meta(items));

  /*
   * GRID2D CELLS
   */

  let items_grid2d_cells_collection = DTO_IMAGE_META__grid2d_cell_collection.filter_by_type(items);
  store.dispatch(LOCAL__collection_cells_upsert(items_grid2d_cells_collection));
}
